const isDesktop = window.innerWidth > 550
if (isDesktop) {
  const mobileAds = document.querySelectorAll(`[data-screen="mobile"]`)
  mobileAds.forEach(x => x.remove())
} else {
  const desktopAds = document.querySelectorAll(`[data-screen="desktop"]`)
  desktopAds.forEach(x => x.remove())
}
